import * as _ from 'lodash';
import {CHOOSE_SUITABLE_OUTAGE} from "../actions/action";
import {put, select, takeEvery} from "redux-saga/effects";
import {AnyAction} from "redux";
import {getOutages, IOutage} from "../../data/data";
import {setOutageID} from "../actions/outages";
import {countPowerSourcesByType} from "../reducers/powerSources";


/**
 * handle outages
 */
export default function* handleOutages()
{
    yield takeEvery(CHOOSE_SUITABLE_OUTAGE, onRequestOutage);
}


/**
 * choose a suitable outage based on game properties
 * @param {AnyAction} action
 */
function* onRequestOutage(action: AnyAction)
{
    // //  get KPIs
    //
    // // const energy_mix: number = yield select(getEnergyMix);
    // // const cost_efficiency: number = yield select(getCost);
    // // const energy_output: number = yield select(getEnergyOutput);
    // // const environmental: number = yield select(getEnvironmental);
    // //
    // // const kpis = {energy_mix, cost_efficiency, energy_output, environmental};
    //
    // //  count how many power sources of each type the user has in play
    //
    // const power_sources: { [id: string]: number } = yield select(countPowerSourcesByType);
    // const placed_source_types: string[] = _.compact(_.map(power_sources, (count: number, type: string) => count && type ? type : null));
    //
    // const source_type: string = _.sample(placed_source_types);
    //
    // //  get all outages
    //
    // const outages: IOutage[] = getOutages();
    //
    // console.group('onRequestOutage');
    // console.log('power_sources', power_sources);
    // console.log('placed_source_types', placed_source_types);
    // console.log('source_type', source_type);
    //
    //
    // // console.log('energy_mix', energy_mix);
    // // console.log('cost_efficiency', cost_efficiency);
    // // console.log('energy_output', energy_output);
    // // console.log('environmental', environmental);
    // // console.log('outages', outages);
    //
    // //  find the first outage whose requirements fit the current game state
    //
    // //  outages affect specific types of power station;
    // //  let's
    //
    //
    //
    //
    // // console.log('relevant_outages', relevant_outages);
    //
    // const outage: IOutage = _.find(outages, outage => outage.affects === source_type);
    //
    // console.log('outage', outage);
    // console.groupEnd();
    //
    // if (! outage) return null;
    //
    // //  add more score
    //
    // yield put(setOutageID(outage.id));
}



// WEBPACK FOOTER //
// ./src/ts/store/sagas/handleOutages.ts